import { assert } from '@fe/core';
import { store } from '../../app/state/store';
import app from '../../client/app';
import { FlightContextMenuDto } from '../../flights/interop/flightDto';
import { EliCustomButton, EliDisplayModeEnum } from '../../types/settings';
import { MessageType } from '../actor-messages';

export enum EliType {
    airplane,
    airport,
    topBar
}

export const ELI_TOKENS = {
    [EliType.airplane]: ['USERID', 'ACID', 'TAILNUM', 'ORIGIN', 'DEST'],
    [EliType.airport]: ['USERID', 'ICAOID', 'IATAID', 'FAAID'],
    [EliType.topBar]: ['USERID']
} as const satisfies Record<EliType, string[]>;

export class EliService {
    static handleAircraft(item: EliCustomButton, flight: FlightContextMenuDto) {
        const state = store.getState();
        assert(state.user.info.isAuthenticated);

        EliService.handle<EliType.airplane>(
            item,
            {
                USERID: state.user.info.name,
                ACID: flight.acid ?? '',
                TAILNUM: flight.regId ?? '',
                ORIGIN: flight.origin ?? '',
                DEST: flight.destination ?? ''
            },
            state.settings.eliDisplayMode
        );
    }
    static async handleAirport(item: EliCustomButton, id: string) {
        const airport = await app.worker.actor.sendAsync({ type: MessageType.findAirport, data: id });
        if (!airport) {
            return;
        }
        const state = store.getState();
        assert(state.user.info.isAuthenticated);

        EliService.handle<EliType.airport>(
            item,
            {
                USERID: state.user.info.name,
                ICAOID: airport.icao ?? '',
                IATAID: airport.iata ?? '',
                FAAID: airport.faa ?? ''
            },
            state.settings.eliDisplayMode
        );
    }

    static async handleTopBar(item: EliCustomButton) {
        const state = store.getState();
        assert(state.user.info.isAuthenticated);

        EliService.handle<EliType.topBar>(
            item,
            {
                USERID: state.user.info.name
            },
            state.settings.eliDisplayMode
        );
    }

    private static handle<T extends EliType>(
        item: EliCustomButton,
        tokens: Record<(typeof ELI_TOKENS)[T][number], string>,
        mode: EliDisplayModeEnum
    ) {
        let url = item.urlTemplate;
        for (const token in tokens) {
            url = url.replaceAll(`#${token}#`, tokens[token as keyof typeof tokens]);
        }

        if (!url) {
            return;
        }

        if (!url.startsWith('http://') && !url.startsWith('https://')) {
            url = 'https://' + url;
        }

        if (mode === EliDisplayModeEnum.newTab) {
            open(url, '_blank');
        } else if (mode === EliDisplayModeEnum.newWindow) {
            open(url, '_blank', 'width=800,height=1000');
        }
    }
}
